import { render, staticRenderFns } from "./discountPop.vue?vue&type=template&id=42502ff2&scoped=true&"
import script from "./discountPop.vue?vue&type=script&lang=ts&"
export * from "./discountPop.vue?vue&type=script&lang=ts&"
import style0 from "./discountPop.vue?vue&type=style&index=0&id=42502ff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42502ff2",
  null
  
)

export default component.exports